module.exports = __webpack_public_path__ + "img/01-T.c3ecb87c.png";